// import { useNavigate, useParams } from 'react-router-dom';

import Home from "./Frontend/Home";
import PageLoader from "./Frontend/PageLoader";

function App() {
  return (
    <div>
      <PageLoader />
      <div className="hero-bg site-scene" aria-hidden="true">
        <div className="hero-aurora" />
        <div className="hero-orb hero-orb-1" />
        <div className="hero-orb hero-orb-2" />
        <div className="hero-orb hero-orb-3" />
        <div className="hero-grid" />
        <div className="hero-dots">
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
        </div>
        <div className="hero-vignette" />
      </div>
      <div className="site-content">
        <Home />
      </div>
    </div>
  );
}

export default App;
